import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// `.init()` resolves once the initial namespace has loaded from the http backend.
// Callers that render translated content on first paint (see main.tsx) must await
// this before mounting, otherwise components render before "translation" is loaded.
export const i18nReady = i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/i18next-http-backend)
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    // only load the exact requested locale (e.g. "es-MX"),
    // do not fall back to the language-only variant ("es") automatically
    load: 'currentOnly',
    // explicitly list supported locales to avoid non-explicit fallback behavior
    supportedLngs: ['en', 'es-MX'],
    nonExplicitSupportedLngs: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    }
  });

export default i18n;
